<template>
  <TransitionSlideInOut appear :origin="SlideOrigin.Right">
    <SlideMenuWrapper :show-close-button="false">
      <div v-click-outside="() => $emit('close-mobile-navigation')" class="mobile-nav">
        <div class="navigation-item" @click="$emit('show-participant-overview')">
          <FriedIcon icon="users" />
          <FriedParagraph :size="ParagraphSize.Large">
            {{ t('participants') }}
          </FriedParagraph>
        </div>
        <div v-if="isPublicRoom" class="navigation-item" @click="openShareModal">
          <FriedIcon icon="share" />
          <FriedParagraph :size="ParagraphSize.Large">
            {{ t('dsr_share') }}
          </FriedParagraph>
        </div>
        <button
          class="powered-by"
          data-external="dsr-powered-by-button"
          :aria-label="t('powered-by-getaccept')"
          @click="handlePoweredByClick"
        >
          <PoweredByLogo />
        </button>
      </div>
    </SlideMenuWrapper>
  </TransitionSlideInOut>
</template>

<script lang="ts">
import { SlideOrigin, ParagraphSize } from '@getaccept/fried-tofu';
import { defineComponent } from 'vue';
import { SlideMenuWrapper, DrView } from '@getaccept/dsr-shared-new';
import { useI18n } from 'vue-i18n';
import PoweredByLogo from '../assets/powered-by-ga.svg';

export default defineComponent({
  components: {
    SlideMenuWrapper,
    PoweredByLogo,
  },
  props: {
    isAllowedToInvite: {
      type: Boolean,
    },
    isPublicRoom: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const handlePoweredByClick = () => window.open('https://www.getaccept.com', '_blank');

    const openShareModal = () => {
      if (!props.isAllowedToInvite) {
        return;
      }
      emit('show-share-modal');
    };

    return {
      SlideOrigin,
      ParagraphSize,
      t,
      DrView,
      handlePoweredByClick,
      openShareModal,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@getaccept/dsr-shared-new/src/scss/slide-navigation-menu';

.powered-by {
  animation: bounce 1s;
  height: 2rem;
  cursor: pointer;
  border: none;
  background: none;
  margin: auto 0 0;

  &:focus {
    outline-color: var(--gray-98);
  }
}

@keyframes bounce {
  0% {
    transform: scale(0);
  }

  80% {
    transform: scale(0);
  }

  90% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}
</style>
